export default [
  // *===============================================---*
  // *--------- ECOMMERCE  ---------------------------------------*
  // *===============================================---*
  {
    path: '/shop',
    name: 'lagermeister-shop',
    component: () =>
      import('@/views/apps/e-commerce/e-commerce-shop/StorageShop.vue'),
    meta: {
      contentRenderer: 'sidebar-left-detached',
      contentClass: 'ecommerce-application',
    },
  },
  {
    path: '/shop/checkout',
    name: 'lagermeister-checkout',
    component: () =>
      import(
        '@/views/apps/e-commerce/e-commerce-checkout/ShopCheckout.vue'
      ),
    meta: {
      contentClass: 'ecommerce-application',
    },
  },
  {
    path: '/shop/storage/:storage_type',
    name: 'shop-product-details',
    component: () =>
      import(
        '@/views/apps/e-commerce/e-commerce-product-details/ShopProductDetails.vue'
      ),
    meta: {
      contentClass: 'ecommerce-application',
    },
  },
  {
    path: '/shop/docupload',
    name: 'lagermeister-docupload',
    component: () =>
      import('@/views/apps/e-commerce/document-upload/LMSDocUpload.vue'),
    meta: {
      contentClass: 'ecommerce-application',
    },
  },
]
